import { FormattedMessage } from 'react-intl';
import { matchPath, useLocation } from 'react-router-dom';

import { LabelL } from '@sorare/core/src/atoms/typography';
import { ExtraMessageWithBlurredBg } from '@sorare/core/src/components/onboarding/ExtraMessageWithBlurredBg';
import { HighlightOverlay } from '@sorare/core/src/components/onboarding/HighlightOverlay';
import { NBA_PLAY } from '@sorare/core/src/constants/__generated__/routes';
import { useIsTabletAndAbove } from '@sorare/core/src/hooks/device/useIsTabletAndAbove';
import { useLifecycle } from '@sorare/core/src/hooks/useLifecycle';
import { useOnboardingHighlights } from '@sorare/core/src/hooks/useOnboardingHighlights';

type Props = {
  claimDialogOpen: boolean;
  hasClaimTaskReady?: boolean;
  setClaimDialogOpen: (open: boolean) => void;
};

export const DailyClaimButtonOnboarding = ({
  claimDialogOpen,
  hasClaimTaskReady,
  setClaimDialogOpen,
}: Props) => {
  const location = useLocation();
  const isTabletAndAbove = useIsTabletAndAbove();
  const onboardingHighlights = useOnboardingHighlights();
  const { lifecycle } = useLifecycle();

  if (
    claimDialogOpen ||
    !hasClaimTaskReady ||
    !onboardingHighlights ||
    lifecycle?.sawDailyClaimButton ||
    !matchPath(NBA_PLAY, location.pathname)
  ) {
    return null;
  }

  return (
    <HighlightOverlay
      stayOpen
      disableBackdropClose
      highlightNames={['DailyClaimButton']}
      onClose={() => {
        setClaimDialogOpen(true);
      }}
      extras={[
        {
          nextTo: 'DailyClaimButton',
          render: props => (
            <ExtraMessageWithBlurredBg
              align="center"
              anchor="bottom"
              positionProps={props}
              fullWidth={!isTabletAndAbove}
            >
              <LabelL>
                <FormattedMessage
                  id="MLB.DailyClaimButtonOnboarding.title"
                  defaultMessage="Claim a daily reward every 24 hours!"
                />
              </LabelL>
            </ExtraMessageWithBlurredBg>
          ),
        },
      ]}
    />
  );
};
